import perfeed from './perfeed.saga';
import profile from './profile.saga';

export default [...perfeed, ...profile];
